import { defineComponent as _defineComponent } from 'vue'
import { inject } from 'vue';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BysoftSidebarEntry',
  props: {
    label: null,
    active: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
    icon: null,
    iconPack: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {





const isSidebarExpanded = inject<boolean>('isSidebarExpanded');

return { __sfc: true,emit, isSidebarExpanded }
}

})